import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "portfolio",
  class: "py-12 portfolio-section bg-red-lighten-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "text-center mb-8"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("h2", { class: "text-h3 font-weight-bold mb-4" }, "Kundenstimmen", -1),
                _createElementVNode("p", { class: "text-h6 font-weight-light" }, "Explore my latest work...", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portfolioItems, (item, i) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                key: i,
                cols: "12",
                md: "4",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "portfolio-card",
                    hover: "",
                    onClick: ($event: any) => (_ctx.openImage(item))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: item.image,
                        height: "300",
                        class: "portfolio-image"
                      }, null, 8, ["src"]),
                      _createVNode(_component_v_card_title, { class: "font-weight-bold" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_card_subtitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.category), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}